import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { FaDiscord, FaXTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa6';

const socialLinks = [
  {
    name: 'Discord',
    url: 'https://discord.gg/Amtkdgf9Jc',
    icon: FaDiscord,
    color: 'hover:text-[#5865F2] hover:border-[#5865F2]/50',
    bgHover: 'hover:shadow-[0_0_20px_rgba(88,101,242,0.3)]'
  },
  {
    name: 'Twitter',
    url: 'https://x.com/thepromptspace',
    icon: FaXTwitter,
    color: 'hover:text-white hover:border-white/50',
    bgHover: 'hover:shadow-[0_0_20px_rgba(255,255,255,0.2)]'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/thepromptspace',
    icon: FaInstagram,
    color: 'hover:text-[#E4405F] hover:border-[#E4405F]/50',
    bgHover: 'hover:shadow-[0_0_20px_rgba(228,64,95,0.3)]'
  },
  {
    name: 'LinkedIn',
    url: 'https://linkedin.com/company/thepromptspace',
    icon: FaLinkedinIn,
    color: 'hover:text-[#0A66C2] hover:border-[#0A66C2]/50',
    bgHover: 'hover:shadow-[0_0_20px_rgba(10,102,194,0.3)]'
  }
];

export const BlogSocialLinks = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="mt-12 p-8 bg-gradient-to-br from-[#00C2FF]/10 via-black/40 to-[#7000FF]/10 
        backdrop-blur-md border border-white/10 rounded-2xl
        shadow-[0_0_40px_rgba(0,194,255,0.08)]"
    >
      <div className="text-center mb-6">
        <div className="flex items-center justify-center gap-2 mb-2">
          <MessageCircle className="w-5 h-5 text-[#00C2FF]" />
          <h3 className="text-xl font-bold font-display bg-gradient-to-r from-[#00C2FF] to-[#7000FF] bg-clip-text text-transparent">
            Join Our Community
          </h3>
        </div>
        <p className="text-white/60 text-sm">
          Connect with prompt engineers and AI enthusiasts worldwide
        </p>
      </div>

      <div className="flex items-center justify-center gap-4">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Follow us on ${social.name}`}
            className={`
              w-12 h-12 rounded-full 
              bg-white/5 border border-white/20
              flex items-center justify-center
              text-white/70 transition-all duration-300
              ${social.color} ${social.bgHover}
            `}
          >
            <social.icon className="w-5 h-5" />
          </a>
        ))}
      </div>
    </motion.div>
  );
};
